// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Thailand */
const TH =
  /^(?:(?:(?:14|[89]\d)\d\d|6(?:[1-6]\d\d|7(?:1[0-8]|2[4-7]|3[1-6])))\d{5})$/;

export default TH;
